import React from "react";
import { ICONS, mapMimeTypeToIcon } from "../icons";

const Icon = ( { icon, iconName, title, size, color, onClick, id, verticalAlign, viewBox, className } ) =>
{
	const styles = {
		svg: {
			display: "inline-block",
			verticalAlign: verticalAlign ? verticalAlign : "baseline"
		},
		path: {
			fill: color ? color : "currentColor"
		}
	};
	
	const typeClass = mapMimeTypeToIcon.hasOwnProperty( iconName ) ? `document ${mapMimeTypeToIcon[ iconName ]}` : iconName;
	
	let props = {};
	
	props[ "className" ] = className ? `icon ${className} ${typeClass}` : `icon ${typeClass}`;
	props[ "viewBox" ] = viewBox ? viewBox : "0 0 1024 1024";
	
	if ( !size )
	{
		props[ "width" ] = "12px";
		props[ "height" ] = "12px";
	}
	else if ( size === "100%" )
	{
		props[ "width" ] = size;
		props[ "height" ] = size;
	}
	else
	{
		props[ "width" ] = size + "px";
		props[ "height" ] = size + "px";
	}
	
	if ( iconName )
	{
		icon = mapMimeTypeToIcon.hasOwnProperty( iconName ) ? ICONS[ mapMimeTypeToIcon[ iconName ] ] : ICONS[ iconName ];
	}
	
	return (
		<svg
			{...props}
			style={styles.svg}
			title={title}
			onClick={onClick}
		>
			{
				Array.isArray( icon )
					? icon.map( ( icon, index ) => <path key={id + "_" + index} style={styles.path} d={icon}/> )
					: <path style={styles.path} d={icon}/>
			}
		</svg>
	);
};

export default Icon;